import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FieldAgentClient, Campaign } from 'ep-bt-field-agent-proxy';

@Component({
  selector: 'epbt-fa-customer-campaigns-list',
  templateUrl: './epbt-fa-customer-campaigns-list.component.html',
  styleUrls: ['./epbt-fa-customer-campaigns-list.component.scss']
})
export class EpbtFaCustomerCampaignsListComponent implements OnInit {

  @Input() customerCampaigns: any[] = [];
  @Input() disabled: boolean = false;
  // private _selectedcampaign: Campaign;
  // @Input('selectedcampaign') set selectedcampaign(value: Campaign) {
  //   this._selectedcampaign = value;
  //   this.campaignChange.emit(this._selectedcampaign);
  // }
  // get selectedcampaign(): Campaign {
  //   return this._selectedcampaign;
  // }
  @Input() isEditable: boolean = true;
  private _selectedcampaign: number;
  @Input('selectedcampaign') set selectedcampaign(value: number) {
    this._selectedcampaign = value;
    if (this._selectedcampaign) {
      var result = this.customerCampaigns.filter(x => x.campaignID == this._selectedcampaign);
      this.campaignChange.emit(result ? result[0] : null);
    }
  }
  get selectedcampaign(): number {
    return this._selectedcampaign;
  }

  @Output() campaignChange = new EventEmitter<any>();

  // @Input() labelText: string = "Campaign";

  constructor(private client: FieldAgentClient) { }

  ngOnInit() {
    this.GetCustomerCampaigns();
  }

  onSelectionChange(selectedValue: any) {
    if (selectedValue) {
      // this.selectedcampaign = selectedValue;
      // this.campaignChange.emit(this.selectedcampaign);
      // console.log("EpbtFaCustomerCampaignsListComponent - onSelectionChange - Start");
      this.selectedcampaign = selectedValue.campaignID;
      var result = this.customerCampaigns.filter(x => x.campaignID == this.selectedcampaign);
      this.campaignChange.emit(result ? result[0] : null);
      // console.log("EpbtFaCustomerCampaignsListComponent - onSelectionChange - End");
    }
  }

  async GetCustomerCampaigns() {
    this.client.getCustomerCampaigns(0).subscribe(res => {
      this.customerCampaigns = res;
      this.campaignChange.emit(res && res.length != 0 ? res[0] : null);
      // console.log("EpbtFaCustomerCampaignsListComponent - GetCustomerCampaigns");
      // console.log(res);
    });
  }

}
